import { daysBetween } from "../../lib/funnel/helpers";
import type { BaselineRow } from "./sql";

export type StageKey =
  | "calendar"
  | "first_transcript"
  | "first_synopsis"
  | "second_synopsis"
  | "first_chat"
  | "custom_template"
  | "paid"
  | "plus"
  | "pro";

export type Stage = {
  key: StageKey;
  label: string;
  short: string;
  dateOf: (u: BaselineRow) => string | null;
};

export const STAGES: Stage[] = [
  { key: "calendar",         label: "Connected calendar",      short: "Calendar",        dateOf: (u) => u.first_calendar_date },
  { key: "first_transcript", label: "First transcript",        short: "Transcript",      dateOf: (u) => u.first_transcript_date },
  { key: "first_synopsis",   label: "First summary",           short: "1st summary",     dateOf: (u) => u.first_synopsis_date },
  { key: "second_synopsis",  label: "Second summary",          short: "2nd summary",     dateOf: (u) => u.second_synopsis_date },
  { key: "first_chat",       label: "Asked Marloo",            short: "Ask Marloo",      dateOf: (u) => u.first_chat_meeting_date },
  { key: "custom_template",  label: "Created custom template", short: "Custom template", dateOf: (u) => u.first_custom_template_date },
  { key: "paid",             label: "Converted to paid",       short: "Paid",            dateOf: (u) => u.subscription_started_date_utc },
  { key: "plus",             label: "Converted to Plus",       short: "Plus",            dateOf: (u) => u.first_plus_date },
  { key: "pro",              label: "Converted to Pro",        short: "Pro",             dateOf: (u) => u.first_pro_date },
];

export type DayOp = "within" | "after" | "ever" | "never";

export type StageTiming = {
  id: string;
  stage: StageKey;
  op: DayOp;
  days: number;
};

let timingCounter = 0;
export const newTimingId = () => `tt${++timingCounter}`;

export function passesTimings(u: BaselineRow, timings: StageTiming[]): boolean {
  for (const t of timings) {
    const stage = STAGES.find((s) => s.key === t.stage);
    if (!stage) continue;
    const milestone = stage.dateOf(u);
    if (t.op === "never") {
      if (milestone) return false;
      continue;
    }
    if (!milestone) return false;
    if (t.op === "ever") continue;
    const days = daysBetween(u.signup_date_utc, milestone);
    if (!Number.isFinite(days) || days < 0) return false;
    if (t.op === "within" && days > t.days) return false;
    if (t.op === "after" && days <= t.days) return false;
  }
  return true;
}

export function describeTiming(t: StageTiming): string {
  const stage = STAGES.find((s) => s.key === t.stage);
  const label = stage?.short ?? t.stage;
  if (t.op === "never") return `${label}: never`;
  if (t.op === "ever") return `${label}: ever`;
  if (t.op === "within") return `${label} within ${t.days}d`;
  return `${label} after ${t.days}d`;
}
